import React from "react";
import { Typography, TypographyProps } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

export interface CustomTypographyProps extends Omit<TypographyProps, "sx"> {
  customColor?: string;
  customFontSize?: string | number;
  customFontWeight?: string | number;
  sx?: SxProps<Theme>;
}

export const CustomTypography = ({
  customColor,
  customFontSize,
  customFontWeight,
  sx,
  className,
  children,
  ...props
}: CustomTypographyProps) => {
  const customStyle: React.CSSProperties = {
    ...(customColor ? { color: customColor } : {}),
    ...(customFontSize ? { fontSize: customFontSize } : {}),
    ...(customFontWeight ? { fontWeight: customFontWeight } : {}),
  };

  return (
    <Typography {...props} className={className} style={customStyle} sx={sx}>
      {children}
    </Typography>
  );
};
